import userService from "../../services/user.service";
import { ActionTypes, feedPageActionTypes } from "../Constants/ActionTypes";

export const setAllFeedPostList = (dispatch, payload) => {
  const { schoolId, page, existingPosts } = payload;
  userService
    .getVideoFeedShow(schoolId, page)
    .then((response) => {
      const posts = response?.data?.data?.shareMediaDetailsResponses;
      if (posts.length === 0) {
        // No more posts to fetch
        dispatch({
          type: feedPageActionTypes.END_TOTAL_POST,
          payload: true,
        });
        return;
      }

      const modifiedPosts = posts?.map((post) => {
        const modifiedPost = post?.commentMediaDetailsList?.map((item) => {
          const commentLastSeen = item?.lastSeen;
          const matches = commentLastSeen?.match(/(\d+)\s+(\w+)\s+Ago/);
          const commentTime = new Date();
          if (matches) {
            const [_, value, unit] = matches;
            const numericValue = parseInt(value);

            if (unit === "Minutes" || unit === "Minute") {
              commentTime.setMinutes(commentTime.getMinutes() - numericValue);
            } else if (unit === "Hours" || unit === "Hour") {
              commentTime.setHours(commentTime.getHours() - numericValue);
            } else if (unit === "Seconds" || unit === "Second") {
              commentTime.setSeconds(commentTime.getSeconds() - numericValue);
            } else if (unit === "Days" || unit === "Day") {
              commentTime.setDate(commentTime.getDate() - numericValue);
            }
          }
          return {
            ...item,
            createdAt: commentTime,
          };
        });
        return {
          ...post,
          commentMediaDetailsList: modifiedPost,
        };
      });

      const mergedPosts = [...existingPosts, ...modifiedPosts];

      dispatch({
        type: feedPageActionTypes.SET_ALL_POST_LIST,
        payload: mergedPosts,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Fetching Feed Posts.",
        },
      });
    });
};

export const likeDislikePost = (dispatch, payload) => {
  const { postId, status } = payload;
  return userService
    .sendLikePost(status, postId)
    .then((response) => {
      if (response.data.success == true) {
        dispatch({
          type: feedPageActionTypes.LIKE_DISLIKE_POST,
          payload: payload,
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong During Like/Dislike Video.",
        },
      });
    });
};

export const addComment = (dispatch, payload) => {
  const { postId, schoolId, commentMessage, userName } = payload;
  return userService
    .addCommentPost(commentMessage, schoolId, postId)
    .then((res) => {
      dispatch({
        type: feedPageActionTypes.ADD_COMMENT,
        payload: { ...payload, createdAt: res?.data?.data?.createdAt },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Adding Comment.",
        },
      });
    });
};

export const setEndTotalPost = (dispatch, payload) => {
  dispatch({
    type: feedPageActionTypes.END_TOTAL_POST,
    payload,
  });
};

export const toggleCoachesAthletesListPopup = (dispatch, payload) => {
  dispatch({
    type: feedPageActionTypes.TOGGLE_ATHLETES_COACHES_LIST_POPUP,
    payload,
  });
};

export const toggleShareVideoPopup = (dispatch, payload) => {
  dispatch({
    type: feedPageActionTypes.TOGGLE_SHARE_VIDEO_POPUP,
    payload,
  });
};

export const handleCoachSelection = (dispatch, payload) => {
  dispatch({
    type: feedPageActionTypes.SELECT_DESELECT_COACHES,
    payload,
  });
};

export const handleAthleteSelection = (dispatch, payload) => {
  dispatch({
    type: feedPageActionTypes.SELECT_DISELECT_ATHLETES,
    payload,
  });
};

export const selectVideo = (dispatch, payload) => {
  dispatch({
    type: feedPageActionTypes.SELECT_VIDEO,
    payload,
  });
};

export const shareVideo = (dispatch, payload) => {
  const {
    eventId,
    eventMediaId,
    scheduleId,
    videoTitle,
    videoDescription,
    athletes,
    coaches,
    schoolId,
    teamAdmins,
    userId,
    shareOnId,
  } = payload;
  return userService
    .postFeedMerge(
      eventId,
      eventMediaId,
      shareOnId,
      videoDescription,
      videoTitle,
      schoolId,
      athletes,
      coaches,
      teamAdmins
    )
    .then((res) => {
      const { id } = res.data.data;
      userService.addActivityVideoShared(
        scheduleId,
        id,
        schoolId,
        userId,
        "CELL",
        "VIDEO_SHARED"
      );

      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Shared Successfully",
            open: true,
          },
        },
      });

      dispatch({
        type: feedPageActionTypes.TOGGLE_ATHLETES_COACHES_LIST_POPUP,
        payload: false,
      });

      dispatch({
        type: feedPageActionTypes.TOGGLE_SHARE_VIDEO_POPUP,
        payload: false,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Sharing Video.",
        },
      });
    });
};
